import {
  RECEIVE_DISPLAY_CLOSE,
  RECEIVE_DISPLAY_OPEN,
  RECEIVE_REMOTE_CLOSE,
  SHARE_OVER_WIRE_RECEIVE,
} from "src/pods/realtime/data/pairing";
import { RECEIVE_GROUPS } from "src/pods/groups";
import { RECEIVE_IDEAS } from "src/pods/ideas";
import { RECEIVE_NOISE, RECEIVE_MICROPHONE_PERMISSION_ERROR } from "src/pods/noise";
import { RECEIVE_RADIO } from "src/pods/radio";

import type { ToolkitAction } from "src/state/toolkitReduxStore";

export type NatsEvent = {
  action: string;
  payload: Record<string, unknown>;
};

/**
 * Maps an incoming NATS event to a Redux action for toolkit.
 * Returns null if the event is not a recognized toolkit action,
 * is a peer-protocol message, or was sent by ourselves.
 */
export function mapNatsToRedux(event: NatsEvent, localClientId: string): ToolkitAction | null {
  const { action, payload } = event;
  const senderId = typeof payload?.senderId === "string" ? payload.senderId : null;

  // Filter self-messages
  if (senderId && senderId === localClientId) {
    return null;
  }

  switch (action) {
    case "toolkit:send-groups":
      return { type: RECEIVE_GROUPS, payload: payload.data };
    case "toolkit:send-radio":
      return { type: RECEIVE_RADIO, payload: payload.data };
    case "toolkit:send-noise":
      return { type: RECEIVE_NOISE, payload: payload.data };
    case "toolkit:send-microphone-error":
      return { type: RECEIVE_MICROPHONE_PERMISSION_ERROR, payload: payload.data };
    case "toolkit:send-ideas":
      return { type: RECEIVE_IDEAS, payload: payload.data };
    case "toolkit:display-open": {
      const { senderId: _, ...rest } = payload;
      return { type: RECEIVE_DISPLAY_OPEN, payload: rest };
    }
    case "toolkit:display-close":
      return { type: RECEIVE_DISPLAY_CLOSE };
    case "toolkit:remote-close":
      return { type: RECEIVE_REMOTE_CLOSE };
    case "toolkit:share-over-wire":
      return { type: SHARE_OVER_WIRE_RECEIVE, payload: payload.action };
    default:
      return null;
  }
}
